export const noOrganizationName = '- ไม่มีชื่อองค์กร -'
